const gamePrefix = 'moonbase'
export const GAME_USER_LANGUAGE = gamePrefix + ':language'
export const GAME_USER_SOUND_VOLUME = gamePrefix + ':soundVolume'
export const GAME_USER_MUSIC_VOLUME = gamePrefix + ':musicVolume'
export const GAME_USER_KEYBINDINGS = gamePrefix + ':keybindings'
export const GAME_USER_MOUSE_SENSITIVITY = gamePrefix + ':mouseSensitivity'
export const GAME_USER_INVERT_Y = gamePrefix + ':invertY'
